import React from 'react';
import { Box, Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const KnowledgeConflictConfirmationDialog = ({ conflict = null, onResolve = () => {} }) => (
  <Dialog
    open={Boolean(conflict)}
    onClose={() => {}}
    fullWidth
    maxWidth="sm"
    aria-labelledby="knowledge-conflict-title"
  >
    <DialogContent sx={{ p: { xs: 2.2, sm: 3 } }}>
      <Stack spacing={2}>
        <Box>
          <Typography id="knowledge-conflict-title" sx={{ fontSize: { xs: '1.3rem', sm: '1.5rem' }, fontWeight: 950, color: colors.semantic.ink }}>
            Is this newer information?
          </Typography>
          <Typography sx={{ mt: 0.6, fontSize: '0.92rem', color: alpha(colors.semantic.ink, 0.68), lineHeight: 1.45 }}>
            This update may replace something currently in Knowledge. Nothing will be deleted.
          </Typography>
        </Box>
        <Stack spacing={1}>
          <Box sx={{ p: 1.2, borderRadius: '14px', bgcolor: alpha(colors.semantic.ink, 0.04) }}>
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 900, color: alpha(colors.semantic.ink, 0.58), textTransform: 'uppercase' }}>Currently saved</Typography>
            <Typography sx={{ mt: 0.3, fontSize: '0.92rem', color: colors.semantic.ink }}>{conflict?.conflict?.summary || conflict?.conflict?.title}</Typography>
          </Box>
          <Box sx={{ p: 1.2, borderRadius: '14px', bgcolor: alpha(colors.semantic.sageDeep, 0.08) }}>
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 900, color: colors.semantic.sageDeep, textTransform: 'uppercase' }}>New update</Typography>
            <Typography sx={{ mt: 0.3, fontSize: '0.92rem', color: colors.semantic.ink }}>{conflict?.draft?.content || conflict?.draft?.title}</Typography>
          </Box>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end">
          <Button variant="outlined" onClick={() => onResolve('keep_both')} sx={{ textTransform: 'none', fontWeight: 900 }}>
            Keep both current
          </Button>
          <Button variant="contained" onClick={() => onResolve('supersede')} sx={{ textTransform: 'none', fontWeight: 900 }}>
            Mark older as no longer current
          </Button>
        </Stack>
      </Stack>
    </DialogContent>
  </Dialog>
);

export default KnowledgeConflictConfirmationDialog;
